import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import ClubService from 'services/ClubService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    clubData: [],
    singleClub:[],
    
}


export const getClub = createAsyncThunk('club/getClub', async (params, { rejectWithValue }) => {
	
	try {
		const response = await ClubService.getClub(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getClubWithId = createAsyncThunk('club/getClubWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await ClubService.getClubWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const createClub = createAsyncThunk('club/createClub', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ClubService.createClub(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const updateClub = createAsyncThunk('club/updateClub', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ClubService.updateClub(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const deleteClub = createAsyncThunk('club/deleteClub', async (data, { rejectWithValue }) => {
	
	try {
		const response = await ClubService.deleteClub(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})


export const clubSlice = createSlice({
    name: 'club',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getClub.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getClub.fulfilled, (state, action) => {
            state.loading = false
            state.clubData = action.payload
        })
        .addCase(getClub.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getClubWithId.pending, (state) => {
            state.loading = true
        })
        .addCase(getClubWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singleClub = action.payload
        })
        .addCase(getClubWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(createClub.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(createClub.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "club Added"
        })
        .addCase(createClub.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(updateClub.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(updateClub.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "club Updated"
        })
        .addCase(updateClub.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
        .addCase(deleteClub.pending, (state) => {
            state.loading = true
            state.message= ''
        })
        .addCase(deleteClub.fulfilled, (state, action) => {
            state.loading = false
           // state.data.unshift(action.payload);
            state.message = "Club deleted"
        })
        .addCase(deleteClub.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
       
       
    }
});


export default clubSlice.reducer;